<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <div class="sn-info-box">
                <Row>
                    <Col span="12">
                        {{$t('mod_cname')}}:{{mod_cname}}
                    </Col>
                </Row>
            </div>
            <Form ref="form" :model="formData" :label-width="120">
                <FormItem :label="$t('select_role')">
                    <CheckboxGroup v-model="formData.cats">
                        <Checkbox v-for="item in cats" :key="item.key" :label="item.key">{{item.value}}</Checkbox>
                    </CheckboxGroup>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        data:function(){
            return{
                relist: false,
                canEditGoodsCode:true,
                dates:[],
                formData: {
                    mod_id: '',
                    cats: [],
                },
                mod_cname: '',
                cats: [],
            }
        },
        computed: {
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.mod_cname = this.$base.getRequest().mod_cname;
            this.formData.mod_id = this.$base.getRequest().id;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                const mod_id = this.formData.mod_id;
                this.$base.showLoading();
                this.$request.sendPost("mod/before-add-role",{mod_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = "mod/add-role";
                this.$base.showLoading();
                this.$request.sendPost(url,this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        },
    }
</script>

<style scoped>

    .other-limit>div div{
        background-color: #eee;
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/mod_role.vue